import { defineStore } from 'pinia'

export const useErrorStore = defineStore('error', {
  state: () => ({
    errorMessage: null as string | null,
  }),
  actions: {
    setError(message: string) {
      this.errorMessage = message
    },
    clearError() {
      this.errorMessage = null
    },
  },
})
